import H7 from '@base/H7/H7';
import P1 from '@base/P1/P1';
import CloudDownload from '@icon/CloudDownload';
import { Spacings, Fonts } from '@styles/index';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styled from '@emotion/styled';

export const MenuItem = styled.li`
  display: grid;
  align-items: center;
  grid-template-columns: 20px 1fr;
  grid-column-gap: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
  cursor: pointer;
  transition: background-color 200ms ease-in-out;
  &:hover {
    background-color: var(--color-divider);
  }
`;

export const MenuItemLabel = styled(P1)`
  font-weight: ${Fonts.SEMIBOLD};
  color: var(--color-text-primary);
`;

const Head = styled.li`
  display: flex;
  margin-top: ${Spacings.SPACING_3B};
  margin-bottom: ${Spacings.SPACING_6};
  padding-left: ${Spacings.SPACING_4B};
  letter-spacing: 0.02em;
`;

const PDFDownload = forwardRef(function PDFDownload(
  { slides, handleClose, isNeoLesson },
  ref
) {
  const openWith = () => {
    window.open(slides.withAnnotations, '_blank');
    handleClose();
  };

  const openWithout = () => {
    window.open(slides.withoutAnnotations, '_blank');
    handleClose();
  };

  if (isNeoLesson && slides.withAnnotations) {
    return (
      <MenuItem ref={ref} onClick={openWith} data-href={slides.withAnnotations}>
        <CloudDownload size="20" color="var(--color-text-secondary)" />
        <MenuItemLabel>Download class pdf</MenuItemLabel>
      </MenuItem>
    );
  }

  return (
    <>
      {slides && (
        <Head ref={ref}>
          <H7 color="var(--color-text-secondary)">DOWNLOAD CLASS PDF</H7>
        </Head>
      )}
      {slides.withAnnotations ? (
        <MenuItem
          ref={ref}
          onClick={openWith}
          data-href={slides.withAnnotations}
        >
          <CloudDownload size="20" color="var(--color-text-secondary)" />
          <MenuItemLabel>With annotation</MenuItemLabel>
        </MenuItem>
      ) : null}
      {slides.withoutAnnotations ? (
        <MenuItem
          ref={ref}
          onClick={openWithout}
          data-href={slides.withoutAnnotations}
        >
          <CloudDownload size="20" color="var(--color-text-secondary)" />
          <MenuItemLabel>Without annotation</MenuItemLabel>
        </MenuItem>
      ) : null}
    </>
  );
});

PDFDownload.propTypes = {
  slides: PropTypes.objectOf(PropTypes.any),
  handleClose: PropTypes.func.isRequired
};

PDFDownload.defaultProps = {
  slides: {}
};

export default PDFDownload;
